<template>
    <section
        class="container"
        id="category_index"
    >
        <h3 class="title">
            {{$t('header.categories')}}
        </h3>
        <template v-if="!loadingCategories && !errorCategories">
            <div class="categories">
                <div
                    class="category"
                    v-for="category in categories"
                    :key="category.id"
                >
                    <h3 class="title">
                        {{category.name}}
                    </h3>
                    <router-link :to="{name: 'video.index', query: {category_id: category.id}}">
                        <div class="img">
                            <img :src="category.public_thumbnail_image_path['small']">
                        </div>
                    </router-link>
                </div>
                <p class="no-records" v-if="categories.length === 0">
                    {{$t('noRecords')}}
                </p>
            </div>
        </template>
        <template v-else>
            <Spinner v-if="loadingCategories"/>
            <template v-if="errorCategories">
                <p>
                    {{$t('error')}}
                </p>
                <button
                    type="button"
                    @click="loadCategories"
                >
                    {{$t('retry')}}
                </button>
            </template>
        </template>
    </section>
</template>

<script>
import Spinner from '../Spinner';
import EventBus from '../../eventbus';
import resources from '../../resources';
import LayoutDefault from "../../layouts/LayoutDefault";

export default {
    components: {
        LayoutDefault,
        Spinner
    },
    methods: {
        loadCategories(){
            this.loadingCategories = true;
            this.categories = null;
            this.errorCategories = false;
            
            resources.movieCategories.index({per_page: 16 * 16})
                .then((response) => {
                    this.loadingCategories = false;
                    this.categories = response.data.data;
                }).catch(() => {
                this.loadingCategories = false;
                this.errorCategories = true;
            });
        },
    },
    data(){
        return {
            loadingCategories: true,
            errorCategories: false,
            categories: null
        }
    },
    mounted(){
        this.loadCategories();
        
        EventBus.$on('languageChanged', () => {
            this.loadCategories();
        });
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

#category_index{
    background-color: var(--pallete_clear_color);
    min-height: 500px;
    padding: 9px;

    .categories{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px;

        .category{
            flex-grow: 0;
            padding: 0 5px;
            margin-bottom: 30px;
            flex-basis: 25%;

            .title{
                text-transform: uppercase;
                margin: 0;
            }


            &.main{

                flex-basis: 100%;
            }

            .img{
                background-color: var(--pallete_secondary_color);
                min-height: 100px;

                img{
                    width: 100%;
                }
            }

            @media(max-width: 900px){
                flex-basis: 50%;
            }

            @media(max-width: 768px){
                flex-basis: 100%;
            }
        }
    }
}

.no-records{
    width: 100%;
}
</style>
